import { useContext } from "react";
import { EnigmaContext } from "@providers/enigmaContext";
import { ConsumerTokens } from "@type/tokens";

// TODO: Exposing this hook instead of `useEnigmaToken` so that only Consumer tokens are exposed and not all the internal tokens

export const useConsumerToken = (): ConsumerTokens => {
    return useContext(EnigmaContext);
};
